module.exports = __webpack_public_path__ + "img/box62.84045fab.png";